import { useTranslation } from 'react-i18next';

const MARKETING_BASE_URL = 'https://giaogas.com';

export function LegalFooter({ className }: { className?: string }) {
  const { t, i18n } = useTranslation(['common', 'auth']);
  const langPrefix = i18n.language === 'en' ? '/en' : '';
  const year = new Date().getFullYear();

  return (
    <footer className={className}>
      <div className="flex items-center justify-center gap-3 text-xs text-muted-foreground">
        <a
          href={`${MARKETING_BASE_URL}${langPrefix}/terms/`}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground hover:underline transition-colors"
        >
          {t('auth:legal.termsAndConditions')}
        </a>
        <span className="opacity-50">|</span>
        <a
          href={`${MARKETING_BASE_URL}${langPrefix}/privacy/`}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground hover:underline transition-colors"
        >
          {t('auth:legal.privacyPolicy')}
        </a>
      </div>
      <p className="text-center text-xs text-muted-foreground mt-2">
        {t('common:footer.copyright', { year })}
      </p>
    </footer>
  );
}
